@charset "UTF-8";

/* src/app/global/components/global-accountinfo-popup/global-accountinfo-popup.component.scss */
:host {
  font-size: 16px;
}
tr {
  line-height: 2rem;
}
td {
  min-width: 150px;
}
td.accountinfo-url {
  max-width: 1px;
  word-wrap: break-word;
}
.accountinfo-background {
  background: var(--color-default-light) url("./media/logo_pharmakon_icon_orange_200px.svg") calc(100% + 15px) -10px/200px no-repeat;
  padding: 80px 60px 50px 60px;
}
.cw-flex-row {
  justify-content: space-between;
}
/*# sourceMappingURL=global-accountinfo-popup.component.css.map */
